import React, { useState, useEffect } from 'react';

import '../css/modal.css';
import DeleteModal from './DeleteModal';
import { decodeToken, getToken } from '../utils/TokenUtils';
import { Button } from 'antd';
import FeatherIcon from 'feather-icons-react';

const DataModal = ({ data, title, editDelPermission={}, isOpen, onRequestClose }) => {
  // Get column headers dynamically
  const headers = data?.length > 0 ? Object.keys(data[0]) : [];
  const [deleteId,setDeleteId]=useState(0);
  const [deleteTable,setDeleteTable]=useState(0);
  const token = getToken();
  const userId = decodeToken(token, 'id');
  const [modalVisible, setModalVisible] = useState(false); // Manage modal visibility
  console.log("permission: ",editDelPermission)
  console.log("headers: ",headers)
    const handleDelete = (table,id) => {
    setDeleteId(id);
    setDeleteTable(table)
    setModalVisible(true); // Open the modal on delete click
    console.log("table ",table," id ",deleteId);
  };

  const handleCancel = () => {
    setModalVisible(false); // Close the modal without deleting
  };
  return (

    <>
    <div
      className={`modal fade ${isOpen ? 'show' : ''}`}
      style={{ display: isOpen ? 'block' : 'none' }}
      tabIndex="-1"
      aria-hidden={isOpen ? 'false' : 'true'}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered"  style={{
    maxWidth: '900px',
    width: '100%',  // to make it responsive
    margin: '1.75rem auto',
  }}>
        <div className="modal-content ">
          <div className="modal-header bg-primary text-white">
            <h5 className="modal-title">{title}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onRequestClose}
            ></button>
          </div>
          <div className="modal-body ">
            {data && data.length > 0 ? (
              <div className="table-responsive">
                <table className="data-table">
                  <thead className="thead-dark">
  <tr>
    {headers
      .filter((header) => header.toLowerCase() !== 'color' && header.toLowerCase() !== 'print' && header.toLowerCase() !== 'can_edit_delete')
      .map((header) => (
        <th key={header}>
          {header.startsWith('delete~')
            ? header.split('~')[1] // Show only alias like 'Tir'
            : header.toUpperCase()}
        </th>
      ))}
  </tr>
</thead>

                <tbody>
  {data.map((item, index) => (
    <tr
      key={index}
      style={item.color ? { backgroundColor: item.color.trim() } : {}}
    >
      {headers
        .filter((header) => header.toLowerCase() !== 'color' && header.toLowerCase() !== 'print' && header.toLowerCase() !== 'can_edit_delete')
        .map((key) => {
         if (key.toLowerCase().startsWith('delete~')) {
  const permission = item['can_edit_delete']; // "1:1", "0:1", etc.
const canDelete = Number(permission?.split(':')[1]) === 1;

if (canDelete) {
  return (
    <td key={key}>
      {item[key] ? (
        <Button
          type="danger"
          onClick={() => {
            const [table, id] = item[key].split('/');
            handleDelete(table, id);
          }}
          size="small"
          icon={
            <FeatherIcon
              icon="trash-2"
              size={16}
              style={{ color: '#dc3545' }}
            />
          }
        />
      ) : null}
    </td>
  );
}
 else {
    return <td key={key}></td>; // Empty cell if no delete permission
  }
}


          // Normal cell rendering
          return (
            <td key={key}>
              {item[key]?.includes?.('<a') ? '' : item[key]}
            </td>
          );
        })}
    </tr>
  ))}
</tbody>

                </table>
              </div>
            ) : (
              <p>Loading...</p>
            )}

            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={onRequestClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>
      
    </div>
  {deleteId && (
        <DeleteModal
          userId={userId}
          token={token}
          table={deleteTable}
          id={deleteId}
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
        />
      )}
  </>  
  );
};

export default DataModal;
